import React, { useRef } from "react";
import { AiFillInfoCircle, AiOutlinePicture } from "react-icons/ai";
import { useSelector } from "react-redux";
import styled from "styled-components";

const PosterPreview = ({ type, variables, setProductImage }) => {
  const fileInput = useRef(null);
  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setProductImage(reader.result);
      console.log(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
    // setFile(file);
  };

  const PosterProductCategoryPreview = ({ variables }) => {
    const options = useSelector((state) => state.custom.options);
    const brands = options?.brands || [];

    return (
      <>
        <div className="product_brand">
          {variables.brand_id
            ? brands.find((d) => d.value == variables.brand_id)?.label ||
              variables.brand_id
            : ""}
        </div>
        <div className="market_block">
          <div
            className="d-flex flex-column align-items-center justify-content-between"
            // style={{
            //   height: 125,
            // }}
          >
            <div>
              {variables.discount_type == "Visai" ? (
                <div className="category_text">
                  <span className="mx-1">-{variables.discount_type_to}</span>
                  {variables.discount_type_symbol}
                </div>
              ) : variables.discount_type == "Iki" ? (
                <div className="category_text">
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    IKI
                  </span>
                  <span className="mx-1">-{variables.discount_type_to}</span>
                  {variables.discount_type_symbol}
                </div>
              ) : (
                <div className="category_text">
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    NUO
                  </span>
                  <span className="mx-1">-{variables.discount_type_from}</span>
                  {variables.discount_type_symbol}
                  <span
                    className="ml-1"
                    style={{
                      fontSize: 12,
                    }}
                  >
                    IKI
                  </span>
                  <span className="mx-1">-{variables.discount_type_to}</span>
                  {variables.discount_type_symbol}
                </div>
              )}
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              NUOLAIDA
            </div>
          </div>
        </div>
      </>
    );
  };
  const PosterProductPreview = ({ variables }) => {
    const variables_price = Number(variables?.price || 0).toFixed(2) || "00.00";
    const variables_price_split = variables_price.split(".");
    const variables_discount_price =
      Number(variables?.discount_price || 0).toFixed(2) || "00.00";
    const variables_discount_price_split = variables_discount_price.split(".");
    return (
      <>
        <div className="market_block">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{
              height: 125,
              margin: "-5px 5px -5px -5px",
            }}
          >
            <div
              className="l_product_text d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#E61D01",
                height: "100%",
                width: "50%",
                borderRadius: "10px 0 0px 10px",
                fontSize:
                  variables.discount_type_from &&
                  typeof variables.discount_type_from == "string" &&
                  variables.discount_type_from.length >= 3
                    ? "40px"
                    : "45px",
              }}
            >
              <nobr>
                -{variables.discount_type_from} {variables.discount_type_symbol}
              </nobr>
            </div>
            <div
              className="d-flex flex-column align-items-end"
              style={{
                width: "50%",
              }}
            >
              <div className="r_top_product_text d-flex align-items-center">
                {variables_price_split[0]}
                <div className="">
                  <div>{variables_price_split[1]}</div>
                  <div>€</div>
                </div>
              </div>
              <div className="r_bottom_product_text d-flex align-items-center">
                {variables_discount_price_split[0]}
                <div className="">
                  <div>{variables_discount_price_split[1]}</div>
                  <div>€</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const imageBlock = () => {
    if (typeof variables.product_image == "string")
      return variables.product_image;
    if (variables.product_image_base64) return variables.product_image_base64;
    if (variables?.product_image?.url) return variables.product_image.url;

    return "transparent";
  };

  const check_if_not_exist_img =
    typeof variables.product_image !== "string" &&
    variables?.product_image?.url == null;
  return (
    <div>
      <PosterPreviewStyled
        id="create_poster"
        className="d-flex flex-column"
        style={{
          width: 359,
          height: 506,
        }}
      >
        <div>
          <div
            className="poster_image"
            style={{
              height: 133,
              backgroundColor: check_if_not_exist_img
                ? "#f8f8f8"
                : "transparent",
              backgroundImage: `url(${imageBlock()})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            onClick={() => fileInput.current?.click()}
          >
            {check_if_not_exist_img && (
              <div className="d-flex flex-column align-items-center justify-content-center h-100 cursor-pointer">
                <AiOutlinePicture size={27} color="#C8C8C8" />
                <p
                  className="text-sm"
                  style={{
                    color: "#C8C8C8",
                  }}
                >
                  Įkelkite nuotrauką
                </p>
              </div>
            )}
            <div className="triggle"></div>
            <div className="triggle"></div>
          </div>
        </div>
        <div className="poster-block">
          {type == "product" ? (
            <h2>{variables.product_title}</h2>
          ) : (
            <>
              <div className="product_category">
                {variables.free_text || variables.product_category}
              </div>
            </>
          )}
          {type == "product" ? (
            <PosterProductPreview variables={variables} />
          ) : (
            <PosterProductCategoryPreview variables={variables} />
          )}
          {type == "product" && variables.special_feature && (
            <div className="special_feature my-2">
              {variables.special_feature}
            </div>
          )}
          <p className="discount_date">
            Pasiūlymas galioja nuo {variables.discount_date_from} iki{" "}
            {variables.discount_date_to}
          </p>
          <p className="legal_text">{variables.legal_text}</p>
        </div>
      </PosterPreviewStyled>

      <div
        className="text-xs d-flex align-items-center mt-3"
        style={{
          color: "#A0A0A0",
        }}
      >
        <AiFillInfoCircle className="text-sm mr-2" color="#A0A0A0" />
        Realus vaizdas gali skirtis nuo numatomo
      </div>
      <input
        className="d-none"
        ref={fileInput}
        type="file"
        onChange={handleFileRead}
      />
    </div>
  );
};

let base64frame =
  "data:image/png;base64,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";

const PosterPreviewStyled = styled.div`
  font-family: Urfa;
  font-style: normal;
  color: #000000;
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: linear-gradient(180deg, #FFE600 0%, #ffc736 100%);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .d-flex {
    display: flex;
  }
   .flex-column {
     flex-direction: column
   } 
    .align-items-end {

    }
    .my-2 {

    }
    .mr-2 {

    }
    .mt-3 {

    }
    .text-xs {

    }
    .text-sm {

    }

  .market_block {
    border: 12px solid transparent;
    border-image: url(${base64frame}) 30 round;

    & .category_text {
      font-style: normal;
      font-weight: 900;
      font-size: 45px;
      line-height: 73px;
    }
    & .l_product_text {
      font-style: normal;
      font-weight: bold;
      line-height: 72px;
      text-align: center;
      text-transform: uppercase;
      color: #ffd101;
    }
    & .r_top_product_text {
      position: relative;
      font-style: normal;
      font-weight: bold;
      font-size: 28.9212px;
      line-height: 42px;
      text-transform: uppercase;
      color: #000000;
      & div {
        font-size: 10.5168px;
        line-height: 15px;
      }
      &::after {
        content: "";
        position: absolute;
        border: 1px solid #000000;
        transform: rotate(-14.21deg);
        width: 100%;
      }
    }
    & .r_bottom_product_text {
      font-style: normal;
      font-weight: bold;
      font-size: 47.94px;
      line-height: 69px;
      text-align: right;
      text-transform: uppercase;
      color: #000000;
      & div {
        font-size: 21.75px;
        line-height: 31px;
      }
    }
  }

  .special_feature {
      margin-top: 8px;
    font-family: Urfa;
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 29px;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;

    border: 1px solid #000000;
    box-sizing: border-box;
    border-radius: 4px;s
  }

  .discount_date {
    font-family: Urfa;
    font-style: normal;
    font-weight: bold;
    font-size: 9px;
    line-height: 13px;
    /* identical to box height */
    
    text-align: center;
    
    color: #000000;
  }

  .legal_text {
    font-family: Urfa;
    font-style: normal;
    font-weight: normal;
    font-size: 9px;
    line-height: 10px;
    text-align: center;
    color: #000000;
  }

  .poster-block {
    padding: 5px 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 25px;
    h2 {
      font-family: Urfa;
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
      text-align: center;
      text-transform: uppercase;
      color: #000000;
    }
    .product_category {
      font-family: Urfa;
      font-style: normal;
      font-weight: 900;
      font-size: 34px;
      line-height: 40px;
      
      text-align: center;
      text-transform: uppercase;
      
      color: #000000;
    }
    .product_brand {
      font-family: Urfa;
font-style: normal;
font-weight: 900;
font-size: 44px;
line-height: 40px;

text-align: center;
text-transform: uppercase;

color: #000000;

    }
  }
  &.market-block {
    border: dashed 5px #e61d01;
  }
  .poster_image {
    position: relative;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .triggle {
    height: 12px;
    background: #ffdf3a;
    bottom: -8px;
    position: absolute;
    width: 50%;
  }
  .triggle:first-child {
    left: 0px;
    transform: rotate(3deg);
  }
  .triggle:nth-child(3) {
    left: 0px;
    transform: rotate(3deg);
  }
  .triggle:nth-child(2) {
    right: 0px;
    transform: rotate(-3deg);
  }
`;

export default PosterPreview;
